
/** @jsx h */
import { h } from 'preact';
import { getImageUrl } from '../../lib/image-url';

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_11-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_11-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_11-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_11-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_11-avatar--right',
  'date': 'dhfc-1_0_0-beta_11-date',
  'date--isFirst': 'dhfc-1_0_0-beta_11-date--isFirst',
  'message': 'dhfc-1_0_0-beta_11-message',
  'message--left': 'dhfc-1_0_0-beta_11-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_11-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_11-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_11-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_11-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_11-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_11-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_11-message__image',
  'message__image--expanded': 'dhfc-1_0_0-beta_11-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_11-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_11-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_11-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_11-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_11-message__name',
  'message__content': 'dhfc-1_0_0-beta_11-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_11-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_11-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_11-message__content--showName'
};


export function AvatarImage(props) {
  var image = props.image,
      alt = props.alt,
      title = props.title;

  return h('img', {
    className: styles.avatarImage,
    title: title,
    src: getImageUrl(image),
    alt: alt,
    nopin: 'no-pin',
    'data-pin-nopin': 'true'
  });
}